import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const regionSchema = z.object({
    name: z.string(),
    displayName: z.string(),
    continent: z.string(),
    endpoint: z.string(),
    doRegion: z.string(),
    awsRegion: z.string(),
    providerName: z.string(),
    isActive: z.boolean(),
    singleDataCenter: z.boolean(),
    isLucidLinkProvided: z.boolean(),
});
export const storageProviderSchema = z.object({
    name: z.string(),
    beta: z.boolean(),
    useVirtualAddressing: z.boolean(),
    locationConstraint: z.boolean(),
    objectStoreType: z.string(),
    defaultBlockSize: z.number(),
    regions: regionSchema.array(),
});
export const storageProvidersSchema = z.object({
    cloudProviders: storageProviderSchema.array(),
});
export class StorageProvidersResponseDto extends createZodDto(storageProvidersSchema) {
}
